import React, { useEffect, useState } from 'react'
import { Helmet } from "react-helmet-async";
import Banner from '../Components/Banner'
import Breadcrumb from './../Components/Breadcrumb';
import pattern from '../Assets/aboutbanner pattern.png';
import InfoSection from '../Components/About/InfoSection';
import aboutImage from '../Assets/about1.png';
import aboutImage2 from '../Assets/about2.jpg';
import aboutImage3 from '../Assets/about3.jpg';
import aboutImage4 from '../Assets/about4.jpg';
import AboutInnovation from './../Components/Homestep';
import WhyStudents from './../Components/About/WhyStudents';
import CardSection from '../Components/About/CardSection';
import cityImage from '../Assets/buildingcareers.png'
import careergirl from '../Assets/careergirl.png'
import topLeftPurple from '../Assets/careerpattern.png'
import bottomRightYellow from '../Assets/careerpattern2.png'
import LookingAheadCard from './../Components/About/LookingAheadCard';
import redBackground from '../Assets/redbackground.png';
import classImage from '../Assets/classimage.jpg';
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const ABout = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: { staggerChildren: 0.2 }
    }
  };

  // Wrapper for conditional animation
  const Wrapper = ({ children, variants = fadeUp, className }) => {
    if (isMobile) {
      return <div className={className}>{children}</div>; // ❌ No animation on mobile
    }
    return (
      <motion.div
        className={className}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={variants}
      >
        {children}
      </motion.div>
    );
  };

  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "AboutPage",
        "name": "About Nova EduBridge",
        "url": "https://novaedubridge.com/about",
        "description": "Learn about Nova EduBridge, a leading study abroad consultancy in Bangalore helping students achieve global education goals."
      },
      {
        "@type": "EducationalOrganization",
        "name": "Nova EduBridge",
        "url": "https://novaedubridge.com/",
        "telephone": "+91-9902043004",
        "email": "info@novaedubridge.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "No.121, 1st Floor, Eshwar Plaza, 4th Main Road, Manjunatha Nagar",
          "addressLocality": "Bangalore",
          "addressRegion": "Karnataka",
          "postalCode": "560010",
          "addressCountry": "IN"
        }
      },
      {
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "What does Nova EduBridge do?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Nova EduBridge helps students with study abroad counselling, university selection, visa assistance, and scholarship guidance."
            }
          },
          {
            "@type": "Question",
            "name": "Where is Nova EduBridge located?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Nova EduBridge is located in Bangalore, Karnataka, India."
            }
          },
          {
            "@type": "Question",
            "name": "Does Nova EduBridge help with scholarships?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Yes, we guide students in applying for scholarships and financial aid to study abroad."
            }
          }
        ]
      }
    ]
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      </Helmet>
      <div>
      <Wrapper>
        <Banner
          className='position-relative'
          subtitle="About Us - Nova EduBridge"
           title="Study Abroad Consultants in Bangalore"
          buttonText="Submit"
          buttonLink="/Contact"
          backgroundImage="/images/about-banner.png"
        />
        <div className='position-absolute patternn'>
          <img src={pattern} alt='pattern'></img>
        </div>
      </Wrapper>

      <Wrapper><Breadcrumb /></Wrapper>

      <Wrapper>
       <InfoSection
  title="About Us"
  subtitle="Nova EduBridge – Trusted Education Consultancy"
  description={<>At Nova EduBridge, a <Link to="/" style={{fontWeight: "600", color: "#d32f2f"}}>Study Abroad Consultants in Bangalore</Link>, we believe that studying in a different country is not just an academic journey—it’s a life-changing experience that shapes your future. Our mission is to guide and empower students who dream of exploring global opportunities, pursuing higher education in foreign universities, and building successful international careers. As an experienced education consultancy, we have helped countless students navigate every step of studying abroad—from choosing the right program to settling into life overseas with confidence.</>}
  image={aboutImage}
  videoLink="https://example.com/video"
/>
      </Wrapper>

      <Wrapper>
        <InfoSection
  title="Our Vision "
  subtitle="and Purpose"
  description="The idea behind Nova EduBridge was born from the realization that many aspiring students are full of potential but lack the right guidance and resources to take their talent to the international stage. Studying abroad opens doors to world-class education, diverse cultural exposure, and career opportunities beyond borders. We help students identify the best country for abroad study based on their goals, budget, and career aspirations, making the journey accessible, smooth, and rewarding for everyone.

Whether you’re seeking an MBA or MS or Medical abroad, considering study abroad programs in specialized fields like medicine or technology, or researching how to study abroad after 12th, we are here to walk alongside you at every stage. From study abroad counselling to scholarship guidance, we bridge the gap between ambition and achievement."
  image={aboutImage2}
  videoLink="https://example.com/video"
  reverse={true}
/>
      </Wrapper>

      <Wrapper>
        <InfoSection
          title="Expert Guidance "
          subtitle="for Every Student"
          description="Our team of experienced study abroad consultants works closely with students to understand their goals, strengths, and challenges. We don’t believe in one-size-fits-all advice—every student’s path is unique, and our role is to design a personalized roadmap that leads to success.

We help you explore different academic destinations and provide detailed advice on how to apply for foreign universities. Whether your interest lies in the best study abroad programs, travel abroad programs, or masters-level courses, we provide you with accurate, up-to-date information so you can make confident choices. Our guidance covers everything—from how to get a scholarship to study abroad to preparing for interviews and securing grants.
"
          image={aboutImage3}
          videoLink="https://example.com/video"
        />
      </Wrapper>

      <Wrapper>
        <InfoSection
          title="Scholarships and "
          subtitle="Financial Support"
          description="We understand that funding is one of the biggest challenges for students who want to study abroad. That’s why Nova EduBridge specializes in helping students discover study abroad scholarships and grants that match their profile. We offer insights into how to apply for scholarships to study abroad and how to maximize your chances of being accepted.

Our advisors have helped secure study abroad scholarships for Indian students in leading universities across the globe. Whether you’re looking for opportunities for masters abroad, need advice on study abroad grants, or want to understand how to study abroad with scholarship funding, we ensure you have access to the resources you need.
"
          image={aboutImage4}
          videoLink="https://example.com/video"
          reverse={true}
        />
      </Wrapper>

      <Wrapper><AboutInnovation /></Wrapper>
      <Wrapper><WhyStudents /></Wrapper>

      <Wrapper className='container mt-5 mb-5 career-grid' variants={staggerContainer}>
        <Wrapper variants={fadeUp}>
          <CardSection
            title="Building Careers Abroad"
            image={cityImage}
            description={[
              "At Nova EduBridge, we are driven by one promise: your success is our success. Every student we work with becomes part of our community. We take pride in the trust that students and their families place in us and strive to provide honest, transparent, and reliable services.",
              "We believe that the opportunity to study abroad should not be limited to a privileged few. That’s why we are dedicated to finding financial solutions, offering Expert Guidance, and ensuring every student has the tools to pursue education beyond borders."
            ]}
            bgColor="#2b2d6e"
            textColor="#ffffff"
            titleColor="#ffffff"
            topLeftPattern={topLeftPurple}
            bottomRightPattern={bottomRightYellow}
          />
        </Wrapper>

        <Wrapper variants={fadeUp}>
          <CardSection
            title="Our Commitment to Students"
            image={careergirl}
            description={[
              "At Nova EduBridge, we are driven by one promise: your success is our success. Every student we work with becomes part of our community. We take pride in the trust that students and their families place in us and strive to provide honest, transparent, and reliable services.",
              "We believe that the opportunity to study abroad should not be limited to a privileged few. That’s why we are dedicated to finding financial solutions, offering Expert Guidance, and ensuring every student has the tools to pursue education beyond borders."
            ]}
            bgColor="#ffffff"
            textColor="#555555"
            titleColor="#d62828"
          />
        </Wrapper>
      </Wrapper>

      <Wrapper>
        <LookingAheadCard
          title="Looking Ahead"
          backgroundImage={redBackground}
          mainImage={classImage}
          description={[
            "The world is changing, and so are the opportunities for education and careers. As technology, globalization, and new industries transform the future, the demand for globally educated professionals is at an all-time high. Nova EduBridge is committed to evolving alongside these changes, continuously expanding our network and enhancing our expertise to serve the next generation of international students. ",
            "Whether you’re dreaming of an MBA or MS or Medical abroad, searching for the best study abroad programs, or simply wondering how to study in a different country, we’re here to make your vision a reality. Our goal is to ensure that when you step into your future classroom overseas, you feel confident, prepared, and ready to embrace the adventure ahead." 
          ]}
        />
      </Wrapper>
      </div>
    </>
  )
}

export default ABout
